export default __webpack_public_path__ + "static/media/img-cwa-user-experience-04.f9412f50.png";